import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { IconCutlery } from "@/components/Icons";
import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import { SelectedInfoBadge } from "@/features/flights/components/additional-services/SelectedInfoBadge";

type Props = {
  required?: boolean;
  selectedAmount?: number;
  onClick: () => void;
};

export const SelectMealCard = ({
  required,
  selectedAmount,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <div className="relative flex flex-col rounded-3xl bg-white p-1">
      <div className="flex items-center gap-1 p-3">
        <IconCutlery className="size-18 shrink-0" />
        <div>
          <div className="font-medium text-text-primary">
            {intl.formatMessage({ id: "travellers.mealSelection" })}
          </div>
          <div className="text-sm text-text-tertiary">
            {intl.formatMessage({ id: "travellers.selectTypeOfMeal" })}
          </div>
          {selectedAmount && selectedAmount > 0 ? (
            <SelectedInfoBadge
              label={intl.formatMessage(
                { id: "travellers.xMealsSelected" },
                { amount: selectedAmount },
              )}
            />
          ) : (
            <SelectedInfoBadge
              label={intl.formatMessage({ id: "travellers.nothingSelected" })}
              dimmed
            />
          )}
        </div>
      </div>
      <div className="p-3 pt-1">
        <Button variant="outlined" fullWidth onClick={onClick}>
          {selectedAmount && selectedAmount > 0
            ? intl.formatMessage({ id: "travellers.editMealSelection" })
            : intl.formatMessage({ id: "travellers.selectMeal" })}
        </Button>
      </div>
      {required ? <RequiredLabel /> : null}
    </div>
  );
};
